import { onCLS, onFID, onFCP, onLCP, onTTFB } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: any) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    try {
      // فراخوانی متریک‌ها
      onCLS(onPerfEntry);
      onFID(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    } catch (error) {
      // مدیریت خطا در هنگام وارد کردن یا فراخوانی
      console.error('Error reporting web vitals:', error);
    }
  }
};

export default reportWebVitals;
